// src/pages/faqData.js

// You can generate unique IDs or use sequential numbers
let questionIdCounter = 0;
const generateId = () => `faq-${++questionIdCounter}`;

export const faqData = [
  {
    categoryKey: 'faq:categories.general', // Key for translation
    questions: [
      { id: generateId(), questionKey: 'faq:general.q1', answerKey: 'faq:general.a1' },
      { id: generateId(), questionKey: 'faq:general.q2', answerKey: 'faq:general.a2' },
      { id: generateId(), questionKey: 'faq:general.q3', answerKey: 'faq:general.a3' },
      { id: generateId(), questionKey: 'faq:general.q4', answerKey: 'faq:general.a4' },
      { id: generateId(), questionKey: 'faq:general.q30', answerKey: 'faq:general.a30' }, // Language support
    ]
  },
  {
    categoryKey: 'faq:categories.features',
    questions: [
      { id: generateId(), questionKey: 'faq:features.q5', answerKey: 'faq:features.a5' },
      { id: generateId(), questionKey: 'faq:features.q6', answerKey: 'faq:features.a6' },
      { id: generateId(), questionKey: 'faq:features.q7', answerKey: 'faq:features.a7' },
      { id: generateId(), questionKey: 'faq:features.q8', answerKey: 'faq:features.a8' },
      { id: generateId(), questionKey: 'faq:features.q9', answerKey: 'faq:features.a9' },
      { id: generateId(), questionKey: 'faq:features.q10', answerKey: 'faq:features.a10' },
      { id: generateId(), questionKey: 'faq:features.q11', answerKey: 'faq:features.a11' },
      { id: generateId(), questionKey: 'faq:features.q12', answerKey: 'faq:features.a12' },
      { id: generateId(), questionKey: 'faq:features.q13', answerKey: 'faq:features.a13' },
    ]
  },
   {
    categoryKey: 'faq:categories.integrations',
    questions: [
       { id: generateId(), questionKey: 'faq:integrations.q14', answerKey: 'faq:integrations.a14' },
    ]
   },
   {
       categoryKey: 'faq:categories.pricing',
       questions: [
           { id: generateId(), questionKey: 'faq:pricing.q15', answerKey: 'faq:pricing.a15' },
           { id: generateId(), questionKey: 'faq:pricing.q16', answerKey: 'faq:pricing.a16' },
        ]
   },
   {
       categoryKey: 'faq:categories.implementation',
       questions: [
            { id: generateId(), questionKey: 'faq:implementation.q17', answerKey: 'faq:implementation.a17' },
            { id: generateId(), questionKey: 'faq:implementation.q18', answerKey: 'faq:implementation.a18' },
            { id: generateId(), questionKey: 'faq:implementation.q19', answerKey: 'faq:implementation.a19' },
        ]
    },
    {
        categoryKey: 'faq:categories.security',
        questions: [
            { id: generateId(), questionKey: 'faq:security.q20', answerKey: 'faq:security.a20' },
            { id: generateId(), questionKey: 'faq:security.q21', answerKey: 'faq:security.a21' },
        ]
    },
     {
        categoryKey: 'faq:categories.support',
        questions: [
            { id: generateId(), questionKey: 'faq:support.q22', answerKey: 'faq:support.a22' },
        ]
     },
    {
        categoryKey: 'faq:categories.demo',
        questions: [
             { id: generateId(), questionKey: 'faq:demo.q23', answerKey: 'faq:demo.a23' },
        ]
    },
     {
         categoryKey: 'faq:categories.comparison', // For objection handling questions
        questions: [
            { id: generateId(), questionKey: 'faq:comparison.q24', answerKey: 'faq:comparison.a24' },
            { id: generateId(), questionKey: 'faq:comparison.q25', answerKey: 'faq:comparison.a25' },
            { id: generateId(), questionKey: 'faq:comparison.q26', answerKey: 'faq:comparison.a26' },
         ]
     },
     {
         categoryKey: 'faq:categories.affiliation',
         questions: [
             { id: generateId(), questionKey: 'faq:affiliation.q27', answerKey: 'faq:affiliation.a27' },
             { id: generateId(), questionKey: 'faq:affiliation.q28', answerKey: 'faq:affiliation.a28' },
             { id: generateId(), questionKey: 'faq:affiliation.q29', answerKey: 'faq:affiliation.a29' },
         ]
     }
];